// Generated by src/build_theme.py from src/taxonomy.py: trucks and their models for My truck and the finder.
window.SME_TAX = {
 "trucks": [
  {
   "value": "HMMWV / Humvee",
   "name": "HMMWV / Humvee",
   "short": "HMMWV",
   "models": [
    "HMMWV 10K (A0, A1)",
    "HMMWV 12K (A2, M1100 series)"
   ]
  },
  {
   "value": "FMTV / LMTV / MTV",
   "name": "FMTV / LMTV / MTV",
   "short": "FMTV",
   "models": [
    "FMTV A0",
    "FMTV A1",
    "FMTV A1P2",
    "LMTV 2.5-ton (M1078 series)",
    "MTV 5-ton (M1083 series)",
    "M1157 10-ton dump",
    "LHS (M1148)"
   ]
  },
  {
   "value": "M939 5-Ton",
   "name": "M939 5-Ton",
   "short": "M939",
   "models": [
    "M939 / M939A1",
    "M939A2"
   ]
  },
  {
   "value": "MTVR 7-Ton",
   "name": "MTVR 7-Ton",
   "short": "MTVR",
   "models": [
    "MTVR MK23",
    "MTVR MK25",
    "MTVR MK27",
    "MTVR MK28",
    "MTVR MK29",
    "MTVR MK30",
    "MTVR MK31",
    "MTVR MK36",
    "MTVR MK37"
   ]
  },
  {
   "value": "LVSR",
   "name": "LVSR",
   "short": "LVSR",
   "models": [
    "LVSR MKR15",
    "LVSR MKR16",
    "LVSR MKR18"
   ]
  },
  {
   "value": "M35 / M44 2.5-Ton",
   "name": "M35 / M44 2.5-Ton",
   "short": "M35/M44",
   "models": [
    "M35 / M44 series"
   ]
  },
  {
   "value": "HEMTT",
   "name": "HEMTT",
   "short": "HEMTT",
   "models": []
  },
  {
   "value": "HET 8x8 / 10x10",
   "name": "HET 8x8 / 10x10",
   "short": "HET",
   "models": []
  },
  {
   "value": "Other Military Vehicles",
   "name": "Other Military Vehicles",
   "short": "other",
   "models": []
  }
 ]
};
